// extracted by mini-css-extract-plugin
export var cls1 = "psychk-module--cls1--zwfWq";
export var svgElem1 = "psychk-module--svgElem1--1yr5Q";
export var active = "psychk-module--active--12ZaC";
export var svgElem2 = "psychk-module--svgElem2--2fJXV";
export var svgElem3 = "psychk-module--svgElem3--30GZZ";